import { BackgroundImage } from 'platform-components';
import React from 'react';

import './custom-lesson-view__image.scss';

interface Props {
    src: string | null;
}

export const CustomLessonViewImage = React.memo(({ src }: Props) => {
    return (
        <BackgroundImage
            layout={BackgroundImage.LAYOUT.STATIC}
            mix="custom-lesson-view__image"
            objectFit="cover"
            src={src}
        />
    );
});
